/* eslint-disable */
import { IAgentSchema } from '../../../../../shared/repositories/offer-card/entities/agent/AgentSchema';
import { IAgentAvailabilityInfoSchema } from '../../../../../shared/repositories/offer-card/entities/agent_availability/AgentAvailabilityInfoSchema';
import { IGetReviewsSchema } from '../../../../../shared/repositories/offer-card/entities/get_reviews/GetReviewsSchema';
import { IOfferOfferAmenitiesGroupSchema } from '../../../../../shared/repositories/offer-card/entities/offer_amenities/OfferOfferAmenitiesGroupSchema';
import { IBreadcrumbForCardItemSchema } from '../../../../../shared/repositories/offer-card/entities/offer/BreadcrumbForCardItemSchema';
import { IBtiDataSchema } from '../../../../../shared/repositories/offer-card/entities/bti_data/BtiDataSchema';
import { IBusinessShoppingCenterNewCardSchema } from '../../../../../shared/repositories/offer-card/entities/business_shopping_center_new_card/BusinessShoppingCenterNewCardSchema';
import { ICompanyWithFeaturesSchema } from '../../../../../shared/repositories/offer-card/entities/company_with_features/CompanyWithFeaturesSchema';
import { ICostEstimateDesktopSchema } from '../../../../../shared/repositories/offer-card/entities/bti_data/CostEstimateDesktopSchema';
import { ICountrysideProjectsSchema } from '../../../../../shared/repositories/offer-card/entities/countryside_project/CountrysideProjectsSchema';
import { IIncludedAmenitiesGroupSchema } from '../../../../../shared/repositories/offer-card/entities/coworking_included_amenities/IncludedAmenitiesGroupSchema';
import { INewbuildingOfferDecorationInfoSchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_offer_decoration/NewbuildingOfferDecorationInfoSchema';
import { IDegradationInfoSchema } from '../../../../../shared/repositories/offer-card/entities/degradation_info/DegradationInfoSchema';
import { IFactoidSchema } from '../../../../../shared/repositories/offer-card/entities/factoids/FactoidSchema';
import { IOfferFeaturesGroupSchema } from '../../../../../shared/repositories/offer-card/entities/offer_features/OfferFeaturesGroupSchema';
import { IFloorPlanSchema } from '../../../../../shared/repositories/offer-card/entities/floor_plan/FloorPlanSchema';
import { IFormattedAreaPartsInfoSchema } from '../../../../../shared/repositories/offer-card/entities/formatted_area_parts_info/FormattedAreaPartsInfoSchema';
import { IHouseCardEntrypointDataSchema } from '../../../../../shared/repositories/offer-card/entities/all_offer_data/HouseCardEntrypointDataSchema';
import { INewbuildingHouseDecorationSchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_decoration/NewbuildingHouseDecorationSchema';
import { IIdenticalOffersSchema } from '../../../../../shared/repositories/offer-card/entities/duplicates/IdenticalOffersSchema';
import { IVillageForIntegrationSchema } from '../../../../../shared/repositories/offer-card/entities/village/VillageForIntegrationSchema';
import { INewBuildingWithFeaturesSchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_with_features/NewBuildingWithFeaturesSchema';
import { INewbuildingDynamicCalltrackingSchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_dynamic_calltracking/NewbuildingDynamicCalltrackingSchema';
import { INewbuildingFlatViewOrderSchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_flat_view_order/NewbuildingFlatViewOrderSchema';
import { INewbuildingsNearbySchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_nearby/NewbuildingsNearbySchema';
import { IGetNoteForOfferResponseSchema } from '../../../../../shared/repositories/offer-card/entities/get_note_for_offer_response/GetNoteForOfferResponseSchema';
import { IOffenceSchema } from '../../../../../shared/repositories/offer-card/entities/offence/OffenceSchema';
import { IOfferSchema } from '../../../../../shared/repositories/offer-card/entities/offer/OfferSchema';
import { IOfferComparisonStatusSchema } from '../../../../../shared/repositories/offer-card/entities/offers_comparison/OfferComparisonStatusSchema';
import { IOfferPriceChangeSchema } from '../../../../../shared/repositories/offer-card/entities/offer_price_change/OfferPriceChangeSchema';
import { IPriceHistoryChartDataSchema } from '../../../../../shared/repositories/offer-card/entities/price_history_chart_data/PriceHistoryChartDataSchema';
import { IPriceInfoSchema } from '../../../../../shared/repositories/offer-card/entities/price_info/PriceInfoSchema';
import { IPriceRelevanceSchema } from '../../../../../shared/repositories/offer-card/entities/price_relevance/PriceRelevanceSchema';
import { IRosreestrInfoSchema } from '../../../../../shared/repositories/offer-card/entities/rosreestr_info/RosreestrInfoSchema';
import { ISeoDataSchema } from '../../../../../shared/repositories/offer-card/entities/seo_data/SeoDataSchema';
import { ISeoLinkSchema } from '../../../../../shared/repositories/offer-card/entities/seo_link/SeoLinkSchema';
import { ISidebarItemSchema } from '../../../../../shared/repositories/offer-card/entities/sidebar/SidebarItemSchema';
import { ISimilarNewObjectSchema } from '../../../../../shared/repositories/offer-card/entities/similar_new_object/SimilarNewObjectSchema';
import { ISpecialProjectItemSchema } from '../../../../../shared/repositories/offer-card/entities/offer/SpecialProjectItemSchema';
import { IOfferStatsSchema } from '../../../../../shared/repositories/offer-card/entities/offer_stats/OfferStatsSchema';
import { ICheckUserSubscriptionV1ItemSchema } from '../../../../../shared/repositories/offer-card/entities/check_user_subscription_v1_item/CheckUserSubscriptionV1ItemSchema';
import { ITourV2Schema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_tour/TourV2Schema';
import { ITransportAccessibilitySchema } from '../../../../../shared/repositories/offer-card/entities/newbuilding_transport_accessibility/TransportAccessibilitySchema';
import { IUserSchema } from '../../../../../shared/repositories/offer-card/entities/user/UserSchema';
import { IUserPhoneShowStatusSchema } from '../../../../../shared/repositories/offer-card/entities/user_phone_show_status/UserPhoneShowStatusSchema';

export interface IAllOfferDataSchema {
  /** Информация по агенту **/
  agent?: IAgentSchema;
  /** Информация о доступности агента **/
  agentAvailability?: IAgentAvailabilityInfoSchema;
  /** Отзывы об агенте **/
  agentReviews?: IGetReviewsSchema;
  /** Группы включенных услуг **/
  amenities?: IOfferOfferAmenitiesGroupSchema[];
  /** Уровень брендинга по подписке **/
  brandingLevel?: EBrandingLevel;
  /** Хлебные крошки **/
  breadcrumbs: IBreadcrumbForCardItemSchema[];
  /** Данные БТИ **/
  bti?: IBtiDataSchema;
  /** Информация о бизнес-центре **/
  businessShoppingCenter?: IBusinessShoppingCenterNewCardSchema;
  /** Информация по компании разместившей объявление **/
  company?: ICompanyWithFeaturesSchema;
  /** Данные оценки - цена и ссылка на калькулятор **/
  costEstimationData?: ICostEstimateDesktopSchema;
  /** Проекты загородки **/
  countrysideProjects?: ICountrysideProjectsSchema;
  /** Включено в аренду коворкинга **/
  coworkingIncludedAmenities?: IIncludedAmenitiesGroupSchema[];
  /** Информация об отделке оффера **/
  decorationInfo?: INewbuildingOfferDecorationInfoSchema;
  /** Информация о деградации **/
  degradationInfo?: IDegradationInfoSchema;
  /** Ссылка на внешнюю карточку объявки **/
  externalOfferUrl?: string;
  /** Фактоиды **/
  factoids?: IFactoidSchema[];
  /** Наборы табличных свойств объекта **/
  features?: IOfferFeaturesGroupSchema[];
  /** План этажа **/
  floorPlan?: IFloorPlanSchema;
  /** Информация о вакантных площадях для объявлений частями **/
  formattedAreaParts?: IFormattedAreaPartsInfoSchema;
  /** [DEPRECATED] Точка входа на карточку дома **/
  houseCardEntrypointData?: IHouseCardEntrypointDataSchema;
  /** Отделка в корпусе **/
  housingDecorations?: INewbuildingHouseDecorationSchema[];
  /** Информация о дублях **/
  identicalOffers?: IIdenticalOffersSchema;
  /** Забронирована ли квартира у застройщика **/
  isBookedFromDeveloper?: boolean;
  /** Оффер находится в избранном у текущего пользователя **/
  isFavorite?: boolean;
  /** Оффер находится в скрытых у текущего пользователя **/
  isHiddenByUser?: boolean;
  /** Доступна регистрация через Циан.Сделка **/
  isOnlineRegistrationAvailable?: boolean;
  /** Информация о коттеджном посёлке **/
  kp?: IVillageForIntegrationSchema;
  /** Ссылка на карту с похожими объявлениями **/
  linkToMap?: string;
  /** Данные по новостройке **/
  newObject?: INewBuildingWithFeaturesSchema;
  /** Информация по динамическому calltracking новостроек **/
  newbuildingDynamicCalltracking?: INewbuildingDynamicCalltrackingSchema;
  /** Информация о записи на просмотр в ЖК **/
  newbuildingFlatViewOrder?: INewbuildingFlatViewOrderSchema;
  /** Новостройки поблизости **/
  newbuildingsNearby?: INewbuildingsNearbySchema;
  /** Заметки пользователя **/
  notes?: IGetNoteForOfferResponseSchema;
  /** Список отзывов модератора **/
  offences?: IOffenceSchema[];
  /** Оффер **/
  offer: IOfferSchema;
  /** Количество подборок текущего пользователя, в которые добавлен оффер **/
  offerFoldersCount?: number;
  /** Статус сравнения объявления **/
  offersComparisonStatus?: IOfferComparisonStatusSchema;
  /** История изменения цены объявления **/
  priceChanges?: IOfferPriceChangeSchema[];
  /** График истории изменеия цены и оценки **/
  priceHistoryChartData?: IPriceHistoryChartDataSchema;
  /** Информация о стоимости **/
  priceInfo?: IPriceInfoSchema;
  /** Актуальность цены **/
  priceRelevance?: IPriceRelevanceSchema;
  /** Информация по росреестру **/
  rosreestrInfo?: IRosreestrInfoSchema;
  /** Данные для SEO-разметки карточки **/
  seoData?: ISeoDataSchema;
  /** SEO перелинковка **/
  seoLinks: ISeoLinkSchema[];
  /** Сайдбар **/
  sidebar?: ISidebarItemSchema[];
  /** Новостройки в том же районе **/
  similarNewObjects?: ISimilarNewObjectSchema[];
  /** Строка запроса для получения новостроек в том же районе **/
  similarNewObjectsQs?: string;
  /** Строка запроса для получения похожих объявлений на карте **/
  similarOffersMapQs?: string;
  /** Спец проект **/
  specialProject?: ISpecialProjectItemSchema;
  /** Статистика по офферу **/
  stats?: IOfferStatsSchema;
  /** Подписка пользователя на изменения цены **/
  subscription?: ICheckUserSubscriptionV1ItemSchema;
  /** Информация о туре по квартире **/
  tourV2?: ITourV2Schema;
  /** URL страницы с метками для трекинга **/
  trackingUrl?: string;
  /** Транспортная доступность **/
  transportAccessibility?: ITransportAccessibilitySchema;
  /** Текущий пользователь **/
  user?: IUserSchema;
  /** Статус по лимиту расхлопов для неавторизованного поискуна (только коммерческая) **/
  userPhoneShowStatus?: IUserPhoneShowStatusSchema;
}
export enum EBrandingLevel {
  'FirstLevel' = 'firstLevel',
  'SecondLevel' = 'secondLevel',
  'ThirdLevel' = 'thirdLevel',
}
